<template>
  <div class="checkbox-container">
    <div class="custom-checkbox" :class="{'checkbox-active' : checked}" @click="changeValue()"/>

    <div class="checkbox-text-container">
      <p class="zero-margin-padding">{{title}}</p>
      <p
        class="checkbox-description zero-margin-padding"
      >{{description}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Checkbox",
  data() {
    return {
      checked: this.value
    };
  },
  props: {
    value: Boolean,
    title: String,
    description: String
  },
  watch: {
    value: function(incoming) {
      this.checked = incoming;
    }
  },
  methods: {
    changeValue() {
      this.checked = !this.checked;
      this.$emit("input", this.checked);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/styles.scss";

$checkbox-size: 30px;

.checkbox-container {
  display: grid;
  grid-template-columns: 20% 80%;

  width: 100%;
  margin-top: 30px;
}

.custom-checkbox {
  width: $checkbox-size;
  height: $checkbox-size;
  background-color: $light-grey-color;
  border: 2px solid rgba(255, 255, 255, 0.363);
  border-radius: 5px;
  cursor: pointer;
  align-self: center;
}

.custom-checkbox:hover {
  background-color: $very-light-grey-color;
}

.checkbox-active, .checkbox-active:hover {
  background-color: $primary-color;
}

.checkbox-text-container {
  align-self: center;
}

.checkbox-description {
  font-size: 10px;
  font-weight: 400;
}
</style>
